export const TagPrimo = () => {
  return (
    <div className="inline-block text-xs font-semibold py-[3px] px-1.5 bg-[#FC677B] rounded-sm text-white h-[22px] whitespace-nowrap">
      Offre primo
    </div>
  );
};
